






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseProfilExclusion from '@/components/profilExclusion/edit/EditBaseProfilExclusion.vue'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'

@Component({
  name: 'EditCodic',    
  components:{EditBaseProfilExclusion}
})
export default class EditCodic extends Vue {
  
  private profilExclusion = getDefaultAloProfilExclusion()  
  private rows = 27

  onResize() {              
    //@ts-ignore                    
    const rowHeight = this.$refs.codicArea?this.$refs.codicArea.rowHeight:20
    //@ts-ignore    
    this.rows = Math.floor((this.$refs.baseEdit.$el.clientHeight - 280) / rowHeight)
  }

  edit(item:AloProfilExclusion) {    
    this.onResize()    
    this.profilExclusion = (this.$refs.baseEdit as EditBaseProfilExclusion).edit(item)    
  }    
}
